"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinParams = exports.getRequestId = exports.hash = void 0;
var bowser_1 = __importDefault(require("bowser"));
var constants_1 = require("./constants");
/* eslint-disable no-bitwise */
function hash(str) {
    var hashCode = 5381;
    var i = str.length;
    while (i) {
        i -= 1;
        hashCode = (hashCode * 33) ^ str.charCodeAt(i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
     * integers. Since we want the results to be always positive, convert the
     * signed int to an unsigned by doing an unsigned bitshift. */
    return hashCode >>> 0;
}
exports.hash = hash;
function genUuid(len) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [];
    for (var i = 0; i < len; i += 1) {
        uuid[i] = chars[0 | (Math.random() * 16)];
    }
    return uuid.join('');
}
function getRequestId() {
    var reqId = window.localStorage.getItem(constants_1.REQUEST_ID) || '';
    if (reqId && reqId.indexOf(":" + constants_1.VERSION + ":") !== -1) {
        return reqId + ":" + Date.now();
    }
    var ua = window.navigator.userAgent;
    var result = bowser_1.default.parse(ua);
    reqId = ["" + result.browser.name + result.browser.version, result.platform.type, constants_1.VERSION, hash(ua), genUuid(16)]
        .join(':')
        .replace(/ /g, '');
    window.localStorage.setItem(constants_1.REQUEST_ID, reqId);
    return reqId + ":" + Date.now();
}
exports.getRequestId = getRequestId;
function joinParams(params) {
    if (!params || typeof params !== 'object') {
        return params;
    }
    var data = [];
    Object.keys(params).forEach(function (key) {
        var val = params[key];
        if (val !== '' && val !== undefined && val !== null) {
            data.push(encodeURIComponent(key) + "=" + encodeURIComponent(val));
        }
    });
    return data.join('&');
}
exports.joinParams = joinParams;
//# sourceMappingURL=utils.js.map